import { type ReactNode } from 'react';
import { ChevronRight } from 'lucide-react';
import { useNavigationContext } from './NavigationContext';
import { NavigationSectionProvider } from './NavigationSectionContext';
import { ButtonLink } from './ButtonLink';
import { cn } from '~/shared/components/utils';

export function NavigationSection({
	label,
	sectionName,
	includeSectionInPath = true,
	children
}: {
	label: string;
	sectionName: string;
	includeSectionInPath?: boolean;
	children: ReactNode;
}) {
	const { toggleSection, expandedSections, selectedRouteSection } = useNavigationContext();
	const expanded = expandedSections.includes(sectionName);
	const selected = selectedRouteSection === sectionName;
	return (
		<NavigationSectionProvider sectionName={sectionName} includeSectionInPath={includeSectionInPath}>
			<ButtonLink label={label} selected={selected} onClick={() => toggleSection(sectionName)}>
				{() => <ChevronRight className={cn('size-4 transition-transform', expanded && 'rotate-90')} />}
			</ButtonLink>
			{expanded && <div className="border-b border-gray-100 last:border-b-0">{children}</div>}
		</NavigationSectionProvider>
	);
}
